import { INVOICE_STATUS, InvoiceStatus } from '../constants'
import type { FilterCondition } from './buildDateFilter'

const STATUS_CONDITIONS: Record<InvoiceStatus, FilterCondition[]> = {
  [INVOICE_STATUS.DRAFT]: [
    { field: 'finalized', operator: 'eq', value: 'false' },
  ],
  [INVOICE_STATUS.FINALIZED]: [
    { field: 'finalized', operator: 'eq', value: 'true' },
  ],
  [INVOICE_STATUS.PAID]: [
    { field: 'paid', operator: 'eq', value: 'true' },
  ],
  [INVOICE_STATUS.UNPAID]: [
    { field: 'finalized', operator: 'eq', value: 'true' },
    { field: 'paid', operator: 'eq', value: 'false' },
  ],
}

const isInvoiceStatus = (value: string): value is InvoiceStatus =>
  Object.values(INVOICE_STATUS).includes(value as InvoiceStatus)

// Only a single status can be sent to the server because the API filter has no OR operator.
// Multi-status selections fall back to client-side filtering via applyStatusFilter.
// Note: UNPAID maps to two conditions (finalized=true AND paid=false) because it is a derived state.
export const buildSingleStatusConditions = (statuses: string[]): FilterCondition[] => {
  if (statuses.length !== 1) return []
  const status = statuses[0]
  if (!isInvoiceStatus(status)) return []
  return STATUS_CONDITIONS[status]
}
